import { red } from '@mui/material/colors';
import { components } from './components';

const themeOptions = {
  typography: {
    fontFamily:
      "'Inter Tight', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 16,
    body1: {
      fontSize: '16px'
    }
  },

  shape: {
    borderRadius: 8
  },

  status: {
    danger: red[500]
  },
  components: {
    ...components
  }
};

export default themeOptions;
